import {
  ArrowCounterClockwise,
  CalendarBlank,
  CheckCircle,
  Flag,
  PaperPlaneTilt,
  Printer,
  WarningCircle,
} from "@phosphor-icons/react";
import {
  NotificationHeaderWrapper,
  NotificationHeader,
  RemindSpan,
} from "../NotificationDrawer/NotificationDrawerStyled";
import PropTypes from "prop-types";

const NotificationStatusHeader = ({ notification_type, is_read }) => {
  const renderHeader = () => {
    switch (notification_type) {
      case "REMIND":
        return (
          <>
            <Flag size={12} color="#9B40C2" weight="fill" />
            <NotificationHeader>Review Requested</NotificationHeader>
            <RemindSpan>(Reminder)</RemindSpan>
          </>
        );
      case "REVIEW_REQUESTED":
        return (
          <>
            <Flag size={12} color="#9B40C2" weight="fill" />
            <NotificationHeader>Review Requested</NotificationHeader>
          </>
        );
      case "DUE_REMINDER":
        return (
          <>
            <CalendarBlank size={12} color="#B26B00" weight="fill" />
            <NotificationHeader color="#B26B00">
              Review Due Soon
            </NotificationHeader>
          </>
        );
      case "REWORK_REQUESTED":
        return (
          <>
            <ArrowCounterClockwise size={12} color="#C24140" weight="fill" />
            <NotificationHeader color="#C24140">Rework Requested</NotificationHeader>
          </>
        );
      case "APPROVED":
        return (
          <>
            <CheckCircle size={12} color="#16B361" weight="fill" />
            <NotificationHeader color="#16B361">Approved</NotificationHeader>
          </>
        );
      case "FAX_RECEIVED":
        return (
          <>
            <Printer size={12} color="#2F6FED" weight="fill" />
            <NotificationHeader color="#2F6FED">Fax Received</NotificationHeader>
          </>
        );
      case "FAX_ATTENTION":
        return (
          <>
            <Printer size={12} color="#9B40C2" weight="fill" />
            <NotificationHeader color="#9B40C2">
              Fax Addressed To You
            </NotificationHeader>
          </>
        );
      case "FAX_SENT":
        return (
          <>
            <PaperPlaneTilt size={12} color="#16B361" weight="fill" />
            <NotificationHeader color="#16B361">Fax Delivered</NotificationHeader>
          </>
        );
      case "FAX_FAILED":
        return (
          <>
            <WarningCircle size={12} color="#C24140" weight="fill" />
            <NotificationHeader color="#C24140">Fax Failed</NotificationHeader>
          </>
        );
      case "DEADLINE_PROPOSED":
        return (
          <>
            <CalendarBlank size={12} color="#B26B00" weight="fill" />
            <NotificationHeader color="#B26B00">
              Deadline Needs Confirmation
            </NotificationHeader>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <NotificationHeaderWrapper opacity={is_read.toString()}>
      {renderHeader()}
    </NotificationHeaderWrapper>
  );
};

NotificationStatusHeader.propTypes = {
  notification_type: PropTypes.string.isRequired,
  is_read: PropTypes.bool.isRequired,
};

export default NotificationStatusHeader;
